import React from "react";
import "./WhyChooseUs.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faBolt,
  faWandMagicSparkles,
  faCode,
  faGaugeHigh,
  faShieldHalved,
  faHeadset,
} from "@fortawesome/free-solid-svg-icons";
import { motion } from "framer-motion";

const cards = [
  {
    icon: faWandMagicSparkles,
    title: "Beautiful, conversion-focused design",
    text: "Modern interfaces with clear hierarchy that build instant trust and guide visitors to take action.",
  },
  {
    icon: faCode,
    title: "Clean, scalable development",
    text: "Production-grade code that's fast, maintainable, and built to grow with your business.",
  },
  {
    icon: faGaugeHigh,
    title: "SEO & speed built in",
    text: "Core Web Vitals optimization and technical SEO from day one — not expensive afterthoughts.",
  },
  {
    icon: faShieldHalved,
    title: "Secure & reliable hosting",
    text: "SSL, backups, and uptime monitoring so your site stays safe and always online.",
  },
  {
    icon: faBolt,
    title: "Fast delivery, fair pricing",
    text: "Clear timelines and transparent pricing with no hidden fees or scope creep.",
  },
  {
    icon: faHeadset,
    title: "Real human help",
    text: "Direct access to your project team — quick responses when you need help, not ticket queues.",
  },
];

const WhyChooseUs = () => {
  return (
    <section className="why" id="why-choose">
      <div className="why__wrap">
        <div className="why__left">
          <motion.p
            className="why__kicker"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.5 }}
          >
            Why Setup Help Online
          </motion.p>

          <motion.h2
            className="why__title"
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.6, delay: 0.05 }}
          >
            Digital solutions that{" "}
            <span className="why__grad">look professional</span> and{" "}
            <span className="why__grad">perform brilliantly</span>.
          </motion.h2>

          <motion.p
            className="why__sub"
            initial={{ opacity: 0, y: 14 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.6, delay: 0.12 }}
          >
            We combine design, development, and marketing so your website doesn't
            just look good — it generates leads, ranks on Google, and scales with
            your ambitions.
          </motion.p>

          <motion.div
            className="why__stats"
            initial={{ opacity: 0, y: 10 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.55, delay: 0.2 }}
          >
            <div className="why__stat">
              <span className="why__statNum">24h</span>
              <span className="why__statText">Proposal turnaround</span>
            </div>
            <div className="why__stat">
              <span className="why__statNum">A+</span>
              <span className="why__statText">Performance scores</span>
            </div>
            <div className="why__stat">
              <span className="why__statNum">100%</span>
              <span className="why__statText">Transparent pricing</span>
            </div>
          </motion.div>
        </div>

        <div className="why__right">
          {cards.map((c, idx) => (
            <motion.article
              key={c.title}
              className="why__card"
              initial={{ opacity: 0, y: 26 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, amount: 0.35 }}
              transition={{ duration: 0.55, delay: idx * 0.08 }}
            >
              <div className="why__icon" aria-hidden="true">
                <FontAwesomeIcon icon={c.icon} />
              </div>
              <h3 className="why__cardTitle">{c.title}</h3>
              <p className="why__cardText">{c.text}</p>
              <div className="why__cardEdge" aria-hidden="true" />
            </motion.article>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;
